/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md: exports a function, not a component. */
import type { CalendarEvent } from '@ilamy/calendar';

import type { SchedulerItem } from './scheduler.types.js';

export function fromCalendarEvent<TPayload>(
  event: CalendarEvent,
  itemsById: Map<string, SchedulerItem<TPayload>>,
): {
  item: SchedulerItem<TPayload>;
  start: Date;
  end: Date;
  resourceId?: string;
} | null {
  const item = itemsById.get(String(event.id));
  if (!item) {
    return null;
  }
  return {
    item,
    start: event.start.toDate(),
    end: event.end.toDate(),
    resourceId: event.resourceId === undefined ? undefined : String(event.resourceId),
  };
}
